import "./_hero.scss";

document.addEventListener("DOMContentLoaded", () => {
  console.log("block loaded");
});